export default "__VITE_ASSET__Cd0Sylh9__"